import React, { useState } from "react";
import PropTypes from "prop-types";
import { Input, Loader } from "semantic-ui-react";

const MAX_PREVIEW_LENGTH = 60;

function formatTimestamp(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const now = new Date();
  const isToday =
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();

  if (isToday) {
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  }
  return date.toLocaleDateString([], { month: "short", day: "numeric" });
}

function truncate(text, maxLength) {
  if (!text) return "";
  return text.length > maxLength ? text.slice(0, maxLength) + "…" : text;
}

const ConversationList = ({ conversations, selectedPhone, onSelect, loading }) => {
  const [search, setSearch] = useState("");

  const filtered = conversations.filter((conv) => {
    const query = search.toLowerCase();
    const name = (conv.applicantName || "").toLowerCase();
    const phone = (conv.phoneNumber || "").toLowerCase();
    return name.includes(query) || phone.includes(query);
  });

  return (
    <div className="wa-conversation-list">
      <div className="wa-conversation-list__search">
        <Input
          fluid
          icon="search"
          placeholder="Search by name or number..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {loading && (
        <div className="wa-conversation-list__loader">
          <Loader active inline="centered" size="small" />
        </div>
      )}

      {!loading && filtered.length === 0 && (
        <div className="wa-conversation-list__empty">No conversations found</div>
      )}

      {!loading && filtered.length > 0 && (
        <div className="wa-conversation-list__items">
          {filtered.map((conv) => {
            const isSelected = conv.phoneNumber === selectedPhone;
            const displayName = conv.applicantName || conv.phoneNumber;
            const itemClassName = isSelected
              ? "wa-conversation-item wa-conversation-item--active"
              : "wa-conversation-item";

            return (
              <div
                key={conv.phoneNumber}
                className={itemClassName}
                onClick={() => onSelect(conv)}
              >
                <div className="wa-conversation-item__avatar">
                  <span>{displayName.charAt(0).toUpperCase()}</span>
                </div>
                <div className="wa-conversation-item__body">
                  <div className="wa-conversation-item__header">
                    <span className="wa-conversation-item__name">{displayName}</span>
                    <span className="wa-conversation-item__time">
                      {formatTimestamp(conv.lastMessageAt)}
                    </span>
                  </div>
                  <div className="wa-conversation-item__preview">
                    <span>
                      {conv.lastMessageDirection === "outbound" && (
                        <span className="wa-conversation-item__you">You: </span>
                      )}
                      {truncate(conv.lastMessage, MAX_PREVIEW_LENGTH)}
                    </span>
                    {conv.unreadCount > 0 && (
                      <span className="wa-conversation-item__badge">{conv.unreadCount}</span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

ConversationList.propTypes = {
  conversations: PropTypes.arrayOf(
    PropTypes.shape({
      phoneNumber: PropTypes.string.isRequired,
      lastMessage: PropTypes.string,
      lastMessageAt: PropTypes.string,
      unreadCount: PropTypes.number,
      applicantName: PropTypes.string,
      applicantId: PropTypes.string,
      zendeskId: PropTypes.string,
      product: PropTypes.string,
    }),
  ).isRequired,
  selectedPhone: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default ConversationList;
